var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPasswordVisible(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Visibility",
    clipPath: "url(#clip0_1528_9551)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00086 4.0008C5.31353 3.95547 2.53419 5.83347 0.786862 7.7568C0.603451 7.96043 0.501953 8.22476 0.501953 8.49881C0.501953 8.77285 0.603451 9.03718 0.786862 9.2408C2.49619 11.1235 5.26753 13.0448 8.00086 12.9988C10.7342 13.0448 13.5062 11.1235 15.2169 9.2408C15.4003 9.03718 15.5018 8.77285 15.5018 8.49881C15.5018 8.22476 15.4003 7.96043 15.2169 7.7568C13.4675 5.83347 10.6882 3.95547 8.00086 4.0008Z",
    fill: "#040506",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.5 8.49969C10.4999 8.99412 10.3531 9.4774 10.0784 9.88843C9.80357 10.2995 9.41307 10.6198 8.95625 10.8089C8.49942 10.998 7.99678 11.0474 7.51187 10.9509C7.02696 10.8544 6.58156 10.6162 6.232 10.2666C5.88243 9.9169 5.6444 9.47144 5.54799 8.9865C5.45158 8.50157 5.50113 7.99894 5.69037 7.54216C5.8796 7.08539 6.20004 6.69498 6.61114 6.4203C7.02225 6.14563 7.50558 5.99902 8 5.99902C8.32839 5.99894 8.65357 6.06356 8.95697 6.18921C9.26036 6.31486 9.53603 6.49906 9.7682 6.7313C10.0004 6.96353 10.1845 7.23924 10.3101 7.54267C10.4356 7.8461 10.5002 8.17131 10.5 8.49969Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1528_9551"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordVisible);
export default __webpack_public_path__ + "static/media/password-visible.b135d2b64df1af1276610f1c1016b43c.svg";
export { ForwardRef as ReactComponent };